import { styled, Typography } from '@mui/material';
import { ArrowUp } from './../../../icon/ArrowUp';
import { ArrowDown } from '../../../icon/ArrowDown';
import { typographyStyles } from '../../../scan/components/DataGridScanStatusField/styles';

export const ProgressionValue = styled(Typography)<{
  direction?: string;
}>(({ theme, direction }) => ({
  ...(direction === 'up' && {
    color: '#dd4234',
  }),
  ...(direction === 'down' && {
    color: '#04bc00',
  }),
  ...typographyStyles(theme),
}));

export const ProgressionContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
`;

export const CustomArrowUp = styled(ArrowUp)(({ theme }) => ({
  ...typographyStyles(theme),
}));

export const CustomArrowDown = styled(ArrowDown)(({ theme }) => ({
  ...typographyStyles(theme),
}));
